import api from './api';
import type { ResumoDashboardVencimentosContract } from '@sstexames/shared-types';

export interface Vencimento {
  colaborador_id: number;
  colaborador_nome: string;
  colaborador_cpf: string;
  colaborador_cargo?: string;
  colaborador_setor?: string;
  data_admissao?: string;
  data_ultimo_exame: string;
  data_vencimento: string;
  prazo_meses: number;
  exame_disparador_nome?: string;
  total_exames_colaborador?: number;
  exposto_a_risco?: boolean;
  motivo_periodicidade?: string;
}

export interface ColaboradorSemData {
  id: number;
  nome: string;
  cpf: string;
  cargo?: string;
  setor?: string;
  data_admissao?: string;
}

export type ResumoDashboardVencimentos = ResumoDashboardVencimentosContract;

class VencimentosService {
  async getVencimentos(): Promise<Record<string, Vencimento[]>> {
    const response = await api.get<Record<string, Vencimento[]>>('/vencimentos-exames');
    return response.data;
  }

  async getVencimentosPorMes(ano: number, mes: number): Promise<Vencimento[]> {
    const response = await api.get<Vencimento[]>('/vencimentos-exames/mes', {
      params: { ano, mes },
    });
    return response.data;
  }

  async getResumoDashboard(): Promise<ResumoDashboardVencimentos> {
    const response = await api.get<ResumoDashboardVencimentos>('/vencimentos-exames/resumo-dashboard');
    return response.data;
  }

  async getColaboradoresSemData(): Promise<ColaboradorSemData[]> {
    const response = await api.get<ColaboradorSemData[]>('/vencimentos-exames/sem-data');
    return response.data;
  }

  async atualizarLoteDatas(
    itens: Array<{ colaborador_id: number; data_ultimo_exame: string }>,
  ): Promise<{ success: boolean; message: string; atualizados: number }> {
    const response = await api.post<{ success: boolean; message: string; atualizados: number }>(
      '/vencimentos-exames/atualizar-lote-datas',
      { itens },
    );
    return response.data;
  }
}

export const vencimentosService = new VencimentosService();
